<template>
  <div class="dashboard-container" id="food-app">
    <!-- 搜索栏 -->
    <div class="tableBar">
      <el-input
        v-model="searchQuery"
        placeholder="请输入食物名称"
        style="width: 250px"
        clearable
        @keyup.enter="init"
      >
        <i
          slot="prefix"
          class="el-input__icon el-icon-search"
          style="cursor: pointer"
          @click="init"
        ></i>
      </el-input>
      <el-button type="primary" @click="addFood"> 新增</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" stripe class="tableBox">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="foodName" label="食物名称" min-width="100"></el-table-column>
      <el-table-column prop="orRice" label="原价" min-width="100"></el-table-column>
      <el-table-column prop="image" label="图片" min-width="100">
        <template #default="scope">
          <img :src="scope.row.image" style="width: 60px; height: 60px;" />
        </template>
      </el-table-column>
      <el-table-column prop="content" label="简介" min-width="100"></el-table-column>
      <el-table-column prop="nowPrice" label="现价" align="right" width="100"></el-table-column>
      <el-table-column label="操作" width="200" align="center" style="display: flex;">
        <template #default="scope" >
          <el-button type="primary" @click="editFood(scope.row)"> 修改</el-button>
          <el-button type="danger" @click="deleteFood(scope.row.id)"> 删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      class="pageList"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <!-- 对话框：编辑/新增食物信息 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible">
      <el-form :model="foodForm" label-width="120px">
        <el-form-item label="ID" v-if="foodForm.id !== null">
          <el-input disabled v-model="foodForm.id"></el-input>
        </el-form-item>
        <el-form-item label="食物名称">
          <el-input v-model="foodForm.foodName"></el-input>
        </el-form-item>
        <el-form-item label="原价">
          <el-input v-model="foodForm.orRice"></el-input>
        </el-form-item>
        <el-form-item label="现价">
          <el-input v-model="foodForm.nowPrice"></el-input>
        </el-form-item>
        <el-form-item label="食物图片:" style="width: 800px">
        <!-- 图片预览 -->
        <div v-if="foodForm.image" class="preview-image">
          <img :src="foodForm.image" alt="食物图片" style="max-width:100%; height: auto;" />
          <el-button type="danger" icon="el-icon-delete" circle @click="removeImage"></el-button>
        </div>
        <!-- 文件上传 -->
        <el-upload
          v-if="!foodForm.image"
          action="http://localhost:8090/file/upload"
          :on-success="handleUploadSuccess"
          list-type="picture-card"
          :limit="1"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>




        <el-form-item label="简介">
          <el-input v-model="foodForm.content"></el-input>
        </el-form-item>
     
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdateFood">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'FoodManager',
  data() {
    return {
      searchQuery: '',
      tableData: [],
      pagesize: 10,
      page: 1,
      totalItems: 0,
      dialogVisible: false,
      dialogTitle: '',
      foodForm: {
        id: null,
        foodName: '',
        orRice: null,
        image: '',
        content: '',
        nowPrice: ''
      },
   
    };
  },
  methods: {
    init(){
      const params = {
        page: this.page,
        pagesize: this.pagesize,
        input: this.searchQuery ? this.searchQuery : undefined
      }
      axios.get('http://localhost:8090/mer/getMyFood',{
          params
        }
      )
        .then(response => {

          this.tableData=response.data.data.records
          this.counts=response.data.data.total
          // 请求成功时的处理逻辑
          console.log(this.tableData)

        })
        .catch(error => {
          // 请求失败时的处理逻辑
          console.error(error); // 输出错误信息
        });
    },
    addFood() {
      this.dialogTitle = '新增';
      this.foodForm = {};
      this.dialogVisible = true;
    },
    editFood(row) {
      this.dialogTitle = '编辑食物';
      this.foodForm = { ...row }; 
      this.dialogVisible = true;
    },
    deleteFood(id) {
      this.$confirm('确认删除此条食物记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.get('http://localhost:8090/mer/deleteFood?id='+id)
          .then(() => {
            this.$message.success("删除成功！");
            this.init();
          });
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.init();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.init();
    },
    handleUploadSuccess(response) {
      this.foodForm.image = response.data;
    },
    handleRemove(file, fileList) {
      this.foodForm.image = '';
    },
    saveOrUpdateFood() {
      if (this.dialogTitle === "新增") {
        // Add new food
        axios.post('http://localhost:8090/mer/addFood', this.foodForm)
          .then(() => {
            this.$message.success("新增成功！");
            this.dialogVisible = false;
            this.init();
          });
      } else {
        // Update existing food
        axios.post('http://localhost:8090/mer/updateFood', this.foodForm)
          .then(() => {
            this.$message.success("修改成功！");
            this.dialogVisible = false;
            this.init();
          });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less" scoped>
.dashboard-container {
  padding: 16px;
}
.tableBar {
  margin-bottom: 16px;
}
</style>